// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "." + {"48":"84a7a1e7","64":"3e730f09","80":"fe1cdb38","205":"51b20f04","694":"69f3d23b","773":"3cf05502","850":"575da777","985":"d0f444cd","996":"22f6d470"}[chunkId] + ".js";
};